module.exports = __webpack_public_path__ + "b54cfd78b4852461f2f47531f247abea.svg";